import { Link, useLocation, useNavigate } from 'react-router-dom';
import { LayoutDashboard, Lightbulb, MessageSquare, LogOut, Settings } from 'lucide-react';
import Logo from './Logo';

const AdminSidebar = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const navItems = [
    { href: '/admin', label: 'Dashboard', icon: LayoutDashboard },
    { href: '/admin/ideas', label: 'Manage Ideas', icon: Lightbulb },
    { href: '/admin/inquiries', label: 'Inquiries', icon: MessageSquare },
    { href: '/admin/settings', label: 'Settings', icon: Settings },
  ];

  const isActive = (path) => location.pathname === path;

  const handleLogout = () => {
    localStorage.removeItem('adminToken');
    navigate('/admin/login');
  };

  return (
    <aside className="fixed left-0 top-0 h-screen w-64 glass border-r border-white/5 flex flex-col" data-testid="admin-sidebar">
      {/* Header */}
      <div className="p-6 border-b border-white/5">
        <Link to="/admin" className="flex items-center gap-3">
          <Logo className="h-8 w-8" />
          <div>
            <span className="font-heading font-bold text-lg text-white block">Bit Buddies</span>
            <span className="text-xs text-slate-500">Admin Panel</span>
          </div>
        </Link>
      </div>

      {/* Navigation */}
      <nav className="flex-1 p-4">
        <ul className="space-y-2">
          {navItems.map((item) => {
            const Icon = item.icon;
            return (
              <li key={item.href}>
                <Link
                  to={item.href}
                  className={`flex items-center gap-3 px-4 py-3 rounded-lg transition-all ${
                    isActive(item.href)
                      ? 'bg-cyan-500/10 text-cyan-400 border border-cyan-500/20'
                      : 'text-slate-400 hover:bg-white/5 hover:text-white'
                  }`}
                  data-testid={`admin-nav-${item.label.toLowerCase().replace(' ', '-')}`}
                >
                  <Icon className="h-5 w-5" />
                  <span className="font-medium">{item.label}</span>
                </Link>
              </li>
            );
          })}
        </ul>
      </nav>

      {/* Footer */}
      <div className="p-4 border-t border-white/5">
        <Link
          to="/"
          className="flex items-center gap-3 px-4 py-2 text-slate-500 hover:text-slate-300 text-sm transition-colors mb-2"
          data-testid="admin-view-site"
        >
          View Public Site
        </Link>
        <button
          onClick={handleLogout}
          className="flex items-center gap-3 px-4 py-3 w-full rounded-lg text-slate-400 hover:bg-red-500/10 hover:text-red-400 transition-all"
          data-testid="admin-logout-btn"
        >
          <LogOut className="h-5 w-5" />
          <span className="font-medium">Logout</span>
        </button>
      </div>
    </aside>
  );
};

export default AdminSidebar;
